import { render, staticRenderFns } from "./onlineService.vue?vue&type=template&id=7ffaa04a&scoped=true&"
import script from "./onlineService.vue?vue&type=script&lang=js&"
export * from "./onlineService.vue?vue&type=script&lang=js&"
import style0 from "./onlineService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffaa04a",
  null
  
)

export default component.exports